module.exports = __webpack_public_path__ + "static/media/elephant.3e1dacac.svg";